import moment from 'moment';

export const getYear = (date) => {
  const dataMoment = moment(date);
  return dataMoment.year();
};
